<template>
<v-app id="app">
    <v-main>
        <core-app-bar />
        <v-container class="mt-0 pt-0">
            <router-view />
        </v-container>
    </v-main>
</v-app>
</template>

<script>
import Api from "@/services/api.js";
import Base from "@/plugins/base.js";

export default {
    name: "App",
    components: {
        CoreAppBar: () => import("@/components/core/AppBar")
    },
    mounted: function () {
        this.$root.$api = new Api()
    }
};
</script>

<style lang="scss">
@import "@/assets/css/variables.scss";
@import "@/assets/css/global.scss";
</style>
